// converts url dates to UTC, should only be called when making GRP API request
export function parseDates(strFrom = "", strTo = "") {
  let fromDate = null,
    toDate = null;

  if (strFrom && strFrom.includes("Range")) {
    [fromDate, toDate] = parseRange(strFrom); // TODO range shouldn't really be appearing in dateFrom
  } else {
    fromDate = parseDate(strFrom);
    toDate = parseDate(strTo);
    if (fromDate.setHours) {
      fromDate.setHours(0, 0, 0, 0);
    }
    if (toDate.setHours) {
      toDate.setHours(23, 59, 59, 0);
    }
    fromDate = fromDate.toISOString && fromDate.toISOString();
    toDate = toDate.toISOString && toDate.toISOString();
  }

  return {
    ...(fromDate && { fromDate: [fromDate] }),
    ...(toDate && { toDate: [toDate] }),
  };
}

function parseRange(range) {
  const [, fromDate, toDate] = range.split("|");
  return [fromDate, toDate];
}

export function parseDate(strDate) {
  if (!strDate) return false;
  let date = new Date();

  switch (strDate) {
    case "1 Week":
      date.setDate(date.getDate() - 7);
      break;
    case "1 Month":
      date.setMonth(date.getMonth() - 1);
      break;
    case "6 Months":
      date.setMonth(date.getMonth() - 6);
      break;
    case "1 Year":
      date.setFullYear(date.getFullYear() - 1);
      break;
    default:
      date = new Date(strDate);
      break;
  }
  return date;
}
